<template>
<!--&lt;!&ndash; 去专柜 &ndash;&gt;-->
<!--<div class="paddingv20 paddingh30 bg-white borderb" v-if="data">-->
    <!--<div class="flex-container padding10" style="background-color:#f8f8f8;">-->
        <!--<div class="img-container" style="width:40px;height:40px;">-->
            <!--<img :src="data.logoImageUrl" alt="" style="width:100%;height:100%">-->
        <!--</div>-->
        <!--<div class="marginl20 fs-12 flex1">-->
            <!--<p class="text-dark" v-text="data.name"></p>-->
            <!--<p class="text-light" v-text="data.address"></p>-->
        <!--</div>-->
        <!--<a :href="data.clickUrl">-->
            <!--<div class="btn red radius small marginr10">去专柜</div>-->
        <!--</a>-->
    <!--</div>-->
<!--</div>-->
<div class="bordert">
    <div class="flex-container paddingv20 paddingh30 bg-white">
        <p class="flex1 text-light fs11">你点“心”的姿势帅爆炸了！</p>
        <div class="btn small reverse" @click="likeThis" style="border-radius:500px;border-color: #e0e0e0;padding: 0px 12px;line-height: 22px;font-size: 12px;">
            <div class="flex-container">
                <i class="icon icon-counter_like fs-14 text-dark marginr10"></i>
                <span class="fs-12 text-dark">喜欢</span>
            </div>
            
        </div>
    </div>
</div>
<!--&lt;!&ndash; 求留印记狗狗图片 &ndash;&gt;-->
<!--<div class="img-container" style="padding-bottom:45px;padding-top:6rem">-->
    <!--<img src="//image1.51tiangou.com/tgou2/img2/discover/gogomessage.png" alt="">-->
<!--</div>-->
</template>

<script>

export default {
//    props:{
//        data: {
//        	type: Object
//            , default: null
//        }
//    },
    methods:{
	    likeThis: function(){
	    	this.$dispatch('likeThis');
        }
    }
}
</script>

<style lang="scss">

</style>